import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbEstadoCivil } from 'app/abstract/full-pages/customs/estado-civil/estado-civil.abstract';

@Injectable({ providedIn: 'root' })
export class EstadoCivilService extends AbEstadoCivil {

  constructor(http: HttpClient) {
    super(http);
  }

  public getAllEstadosCivis(): Observable<any> {
    return this.get("public/estados_civis/");
  }

}